<template>
  <Combobox as="div" v-model="selectedLocation" :disabled="disabled">
    <div class="relative mt-1">
      <ComboboxInput
        :name="name"
        :placeholder="placeholder"
        :class="[v?.$error ?
               'border-red-200 text-red-500/90 focus:ring-red-500/90 focus:border-red-500/90' :
               'border-blue-200 focus:ring-blue-500/90 text-blue-500/90',
             'shadow-sm block font-semibold w-full text-sm focus:bg-whitesmoke-100  border-2 rounded-xl  tabular-nums tracking-wide',
             disabled ? 'opacity-50 cursor-not-allowed' : '']"
        @change="query = $event.target.value" :display-value="(location) => location?.description"  autocomplete="off" />
      <ComboboxButton @click="selectedLocation = null; query = ''; suggestions = []"
        class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
        <font-awesome-icon v-if="!disabled" class="h-5 w-5 text-gray-400" aria-hidden="true"
          :icon="['fasr', selectedLocation ? 'circle-xmark' : 'magnifying-glass']" />
      </ComboboxButton>
      <transition enter-active-class="transition duration-100 ease-out" enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100" leave-active-class="transition duration-75 ease-out"
        leave-from-class="transform scale-100 opacity-100" leave-to-class="transform scale-95 opacity-0">
        <ComboboxOptions v-if="suggestions.length > 0"
          class="max-h-60 w-full overflow-auto z-auto bg-white border-solid border-stone-300 border-[1px] rounded-3xs absolute right-0 mt-2">
          <ComboboxOption v-for="location in suggestions" :key="location.place_id" :value="location" as="template"
            v-slot="{ active, selected }">
            <li
              :class="['relative cursor-pointer select-none py-2 pl-3 pr-9', active ? 'bg-indigo-50 text-indigo-500' : 'text-gray-900']">
              <div class="flex items-center">
                <font-awesome-icon :icon="['fasr', 'location-pin']" />
                <span :class="['ml-3 truncate', selected && 'font-semibold']">
                  {{ location.description }}
                </span>
              </div>

            </li>
          </ComboboxOption>
        </ComboboxOptions>
      </transition>

    </div>
  </Combobox>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { watchDebounced } from '@vueuse/core'
import { Loader } from "@googlemaps/js-api-loader"
import axios from 'axios'
import { onMounted } from "vue"; // this is for my next step
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxLabel,
  ComboboxOption,
  ComboboxOptions,
} from '@headlessui/vue'


const suggestions = ref([]);

const selectedLocation = ref(null)

const model = defineModel()

const props = defineProps({
    v: Object,
    name: String,
    placeholder: String,
    disabled: {
        type: Boolean,
        default: false
    },
});


onMounted(async () => {
  const loader = new Loader({
    apiKey: import.meta.env.VITE_APP_GOOGLE_MAPS_API_KEY, //standard vite env implementation
    version: 'weekly',
    language: 'de'
  })

  const maps = await loader.importLibrary('places')

  const autocomplete = new maps.AutocompleteService()
  const places = new maps.PlacesService(document.createElement('div'))


  if(!selectedLocation.value) {
    selectedLocation.value = {
      description: model.value?.location
    }
  }

  watchDebounced(query, (newValue) => {
    autocomplete.getPlacePredictions({
      input: query.value,
      types: ['(cities)'],
    }, (predictions, status) => {
      if (status === 'OK') {
        suggestions.value = predictions
        return predictions
      }
    })
  }, {
    debounce: 500,
    maxWait: 1000
  })

  watch(selectedLocation, (newValue) => {
    if (newValue) {
      places.getDetails({
        placeId: newValue.place_id
      }, async (place, status) => {
        if (status === 'OK') {

          const options = {
            method: 'GET',
            url: 'https://bodygraph-api-308221027737.europe-west3.run.app/timezone',
            params: {latitude: place.geometry.location.lat(), longitude: place.geometry.location.lng()},
            headers: {
              Authorization: 'Bearer 25hdjlIqXRezLyghI7QQBJ0Dh5nnoZ7Q'
            }
          };

          const timezoneData = await axios.request(options);

          if (timezoneData.data.timeZone) {     
            props.v.$touch()     
            model.value = {
              timeZone: timezoneData.data.timeZone,
              location: place.name
            } 
          }
        }
      })
    } else {
      model.value = null
      props.v.$touch()     
    }
  })
})





const query = ref('')

</script>